import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

import './high-impact-controls.scss';

export function HighImpactControlsDots({ slides, updateSelectedSlide, selectedSlideIndex }) {
  return (
    <div className="high-impact-controls-dots pb-2 pos-a top-0 right-0 mt-2 me-2_5 pe-1_5" role="tablist">
      {slides.map((slideItem, index) => (
        <div xs={12 / slides.length} key={slideItem.id} role="presentation">
          <Button
            onClick={updateSelectedSlide}
            value={index}
            className={classNames('p-0 m-0_5', {
              'selected-button': selectedSlideIndex === index,
            })}
            role="tab"
            id={`tab-dot-${slideItem.id}`}
            aria-selected={selectedSlideIndex === index}
            aria-controls={`tabpanel-${slideItem.id}`}
            style={{
              width: '12px',
              height: selectedSlideIndex === index ? '32px' : '12px',
            }}
          >
            <ContentFragment componentToUse="span" classes="visually-hidden">
              {slideItem.metadata('advertiserName').value()}
            </ContentFragment>
          </Button>
        </div>
      ))}
    </div>
  );
}

HighImpactControlsDots.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateSelectedSlide: PropTypes.func.isRequired,
  selectedSlideIndex: PropTypes.number.isRequired,
};
